import { Button, Separator, TextDisplay, Wrapper } from "src/styled";
import { translate } from "src/services";

interface Props {
  handleScheduleAnotherPickup: () => void;
}

const WelcomeBackScreen = ({ handleScheduleAnotherPickup }: Props) => {
  return (
    <Wrapper
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      margin="no auto"
      minHeight="70vh"
    >
      <TextDisplay
        size="xLarge"
        block
        weight="medium"
        margin="large no no"
        lineHeight="120%"
      >
        {translate("wizardPage.welcomeBackHeading")}
      </TextDisplay>
      <Separator height={10} />
      <TextDisplay
        size="medium"
        margin="xSmall no no"
        desktopMargin="medium no no"
        lineHeight="120%"
        block
        align="center"
      >
        {translate("wizardPage.welcomeBackSubHeading")} &nbsp;
      </TextDisplay>
      <Separator height={50} />
      <Button
        type="submit"
        color="primary"
        size="medium"
        borderRadius="100px"
        onClick={handleScheduleAnotherPickup}
      >
        {translate("wizardPage.scheduleAnotherPickup")}
      </Button>
      <Separator height={100} />
    </Wrapper>
  );
};

export default WelcomeBackScreen;
